/**
 * Models Domain API Schemas
 *
 * Zod schemas for the Models API domain
 */

import { ModelsListResponseSchema } from "./schemas";

export const ZModels = {
  List: {
    method: "GET" as const,
    path: "/api/models",
    Response: ModelsListResponseSchema
  }
} as const;
